import React from 'react';
import {
	Container,
	Section,
	SectionCheckbox,
	SectionContainer,
} from './ContentSkeleton.styles';
import { Skeleton } from '@welbe/web-design-system';

export const ContentSkeleton = ({ loading }: { loading?: boolean }) => {
	if (!loading) {
		return null;
	}

	return (
		<Container>
			<Section>
				<Skeleton width="170px" />
				<SectionCheckbox>
					<Skeleton width="24px" height="24px" />
					<Skeleton width="100%" height="40px" />
				</SectionCheckbox>
				<Skeleton width="400" height="100px" />
				<SectionCheckbox>
					<Skeleton width="24px" height="24px" />
					<Skeleton width="100%" height="40px" />
				</SectionCheckbox>
				<SectionCheckbox>
					<Skeleton width="24px" height="24px" />
					<Skeleton width="100%" height="40px" />
				</SectionCheckbox>
				<SectionCheckbox>
					<Skeleton width="24px" height="24px" />
					<Skeleton width="100%" height="40px" />
				</SectionCheckbox>
			</Section>
			<Section>
				<Skeleton width="170px" />
				<SectionContainer>
					<Skeleton width="100%" height="340px" />
				</SectionContainer>
			</Section>
		</Container>
	);
};
